import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import Customize from './pages/Customize'
import Measurements from './pages/Measurements'
import Checkout from './pages/Checkout'

function Home() {
  const products = [
    {
      id: 1,
      name: "Bloom Cream",
      description: "Elegant cream dress with floral details",
      price: 6000,
      image: "/images/dress1.jpg",
    },
    {
      id: 2,
      name: "Vintage Rose",
      description: "Romantic rose-inspired vintage design",
      price: 6000,
      image: "/images/dress2.jpg",
    },
    {
      id: 3,
      name: "Floral Berry",
      description: "Beautiful berry-toned floral pattern",
      price: 6000,
      image: "/images/dress3.jpg",
    },
    {
      id: 4,
      name: "Clementine Garden",
      description: "Warm citrus-toned floral dress for sunny days",
      price: 6000,
      image: "/images/dress4.jpg",
    },
    {
      id: 5,
      name: "Twilight Meadow",
      description: "Elegant evening dress inspired by dusky meadows",
      price: 6000,
      image: "/images/dress5.jpg",
    }
  ]

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 to-pink-100">
      <div className="max-w-7xl mx-auto px-4 py-16 text-center">
        <h1 className="text-5xl font-bold text-rose-800 mb-4">Vain Boutique</h1>
        <p className="text-xl text-rose-600 mb-12">Custom Dresses Made Just for You</p>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {products.map((product) => (
            <div key={product.id} className="bg-white p-4 rounded-2xl shadow-md hover:shadow-lg transition group">
              <div className="w-full h-48 mb-3 overflow-hidden rounded-lg">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-300"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <h3 className="font-bold text-base mb-1">{product.name}</h3>
              <p className="text-gray-500 text-xs mb-2 line-clamp-2">{product.description}</p>
              <p className="text-rose-600 font-bold text-sm mb-3">PKR {product.price.toLocaleString()}</p>
              <Link to={`/customize/${product.id}`} className="inline-block bg-rose-600 text-white text-sm px-4 py-1.5 rounded-full hover:bg-rose-700 transition w-full text-center">
                Customize →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/customize/:id" element={<Customize />} />
        <Route path="/measurements" element={<Measurements />} />
        <Route path="/checkout" element={<Checkout />} />
      </Routes>
    </Router>
  )
}

export default App
